<template>
  <div class="navbar">
    <div class="container container-fluid">
      <div class="navbar-brand mx-auto text-white">
        Ferramenta de Autoavaliação da Competência Digital dos Professores
      </div>
    </div>
  </div>
</template>
